function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgDiamond = function SvgDiamond(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 439.5 439.5",
    style: {
      enableBackground: "new 0 0 439.5 439.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_27_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7FDDD3"
    },
    points: "359.39,55.215 429.27,152.185 359.38,152.185 289.51,152.185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7FDDD3"
    },
    points: "149.76,152.185 219.84,384.285 10,152.185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7FDDD3"
    },
    points: "219.63,55.215 149.76,152.185 79.88,55.215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95EFEF"
    },
    points: "79.88,55.215 149.76,152.185 10,152.185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "429.5,152.385 219.84,384.285 289.51,152.185 359.38,152.185 429.27,152.185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "359.39,55.215 289.51,152.185 219.63,55.215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95EFEF"
    },
    points: "219.63,55.215 289.51,152.185 149.76,152.185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95EFEF"
    },
    points: "289.51,152.185 219.84,384.285 149.76,152.185  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 429.68,152.185 429.5,152.385 219.84,384.285 10,152.185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: "10,152.185  79.88,55.215 149.76,152.185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: "149.76,152.185  219.63,55.215 289.51,152.185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: "289.51,152.185  359.39,55.215 429.27,152.185 359.38,152.185  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: "79.88,55.215  219.63,55.215 359.39,55.215  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 149.76,152.185 219.84,384.285 289.51,152.185  "
  })))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiamond, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/diamond.df06b628.svg";
export { ForwardRef as ReactComponent };